import styled from 'styled-components';

export const Container = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 3px 2px 3px 6px;
  border: 1px solid ${(props) => props.theme.$gray400};
  border-radius: 4px;
  background: ${(props) => props.theme.$white};

  .material-icons {
    font-size: 18px;
    color: ${(props) => props.theme.$gray600};
  }

  select {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  &:focus-within {
    border-color: ${(props) => props.theme.$primary};
    box-shadow: 0 0 0 2px ${(props) => props.theme.$primary_medium};
  }

  &.disabled {
    opacity: 0.6;

    select {
      cursor: not-allowed;
    }
  }
`;
